import { z } from "zod";

export const patchPartnershipReferenceCalculationTypeJsonSchema = z.object({
	calculationType: z.enum(["service", "hourly"]),
});

export type PatchPartnershipReferenceCalculationTypeJsonSchema = z.infer<
	typeof patchPartnershipReferenceCalculationTypeJsonSchema
>;
